import React, { useState, useEffect, useRef } from 'react'
import './trade-portal-container.styles.scss'
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified'
import { Route, Routes, Navigate } from 'react-router-dom'
import TradePortalBrowse from './trade-portal-browse.component'
import TradePortalNewPost from './trade-portal-new-post.component'
import TradePortalPostDetail from './trade-portal-post-detail.component'
import ImageContainer from '../image-container/image-container.component'

const TradePortalContainer = ({ gameData, playerData, gameElements, playerList}) => {
  const [tradePosts, setTradePosts] = useState({})
  const [loading, setLoading] = useState(true)
  const listenerRef = useRef(null)
  const tradePostsRef = useRef({})

  useEffect(() => {
    if (!gameData?.gameId) return
    tradePostsRef.current = {}
    setTradePosts({})
    getQueryFromFirestore({
      path: `games/${gameData.gameId}/tradePortal`,
      callback: (data, docId) => {
        tradePostsRef.current = { ...tradePostsRef.current, [docId]: data }
        setTradePosts({ ...tradePostsRef.current })
      },
      handleListener: (unsub) => {
        listenerRef.current = unsub
        setLoading(false)
      },
    })
    return () => { if (listenerRef.current) listenerRef.current() }
  }, [gameData?.gameId])

  return (
    <div className='trade-portal-container'>
      <div className='trade-portal-card g-card'>
        <div className='player-title'>
          <ImageContainer
            src='/images/icons/tradeportal.png'
            alt='trade portal icon'
            className='player-title-icon'
          />
          Trade Portal
        </div>
        <hr />
        <Routes>
          <Route path='/' element={
            <TradePortalBrowse
              tradePosts={tradePosts}
              loading={loading}
              gameData={gameData}
              playerData={playerData}
              gameElements={gameElements}
              playerList={playerList}
            />
          } />
          <Route path='newpost' element={
            <TradePortalNewPost
              gameData={gameData}
              playerData={playerData}
              gameElements={gameElements}
            />
          } />
          <Route path='post/:postId' element={
            <TradePortalPostDetail
              tradePosts={tradePosts}
              gameData={gameData}
              playerData={playerData}
              gameElements={gameElements}
              playerList={playerList}
            />
          } />
          <Route path='*' element={<Navigate replace to='.' />} />
        </Routes>
      </div>
    </div>
  )
}

export default TradePortalContainer
